import React from 'react';
import { Modal } from 'antd';
import { svg } from '../assets/svg/common.js'

const CommonLoader = () => {
    return (
        <>
            <div className="common-loader-section">
                <Modal className="modal-loader" open={true} closeIcon={null} footer={null}>
                    <div className={"loader-container"}>
                        {svg.loader}
                    </div>
                </Modal>
            </div>
        </>
    );
};


export default CommonLoader;
